import { actionCreator } from 'utils';
import * as EmailTemplateTypes from '../types/emailTemplateTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    printLabelPopup: false,
    offset: 0,
    limit: 50,
    isSubmittingTemplate: false,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    edit: {
        loading: false,
        data: null,
        error: false,
    },
    tags: {
        loading: false,
        data: null,
        error: false,
    },
    filters: {
        resellerShop: undefined,
        language: undefined,
        type: undefined,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case EmailTemplateTypes.LOAD_EMAIL_TEMPLATE:
        return Object.assign({}, state, {
            ...state,
            loading: true,
        });
    case actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            error: true,
        });
    case actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            listing: action.data,
        });

    case EmailTemplateTypes.SET_EMAIL_TEMPLATE_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case EmailTemplateTypes.SET_EMAIL_TEMPLATE_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case EmailTemplateTypes.RESET_EMAIL_TEMPLATE_FILTERS:
        return Object.assign({}, state, {
            ...state,
            filters: {
                ...initState.filters,
            },
        });

    case EmailTemplateTypes.EDIT_EMAIL_TEMPLATE:
        return Object.assign({}, state, {
            ...state,
            isSubmittingTemplate: true,
        });
    case actionCreator(EmailTemplateTypes.EDIT_EMAIL_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmittingTemplate: false,
        });
    case actionCreator(EmailTemplateTypes.EDIT_EMAIL_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmittingTemplate: false,
        });

    case EmailTemplateTypes.ADD_EMAIL_TEMPLATE:
        return Object.assign({}, state, {
            ...state,
            isSubmittingTemplate: true,
        });
    case actionCreator(EmailTemplateTypes.ADD_EMAIL_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmittingTemplate: false,
        });
    case actionCreator(EmailTemplateTypes.ADD_EMAIL_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmittingTemplate: false,
        });

    case EmailTemplateTypes.LOAD_EDITABLE_EMAIL_TEMPLATE:
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: true,
            },
        });
    case actionCreator(EmailTemplateTypes.LOAD_EDITABLE_EMAIL_TEMPLATE, 'err'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: false,
                error: true,
            },
        });
    case actionCreator(EmailTemplateTypes.LOAD_EDITABLE_EMAIL_TEMPLATE, 'res'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                data: action.data,
                loading: false,
                error: false,
            },
        });

    case EmailTemplateTypes.LOAD_EMAIL_TEMPLATE_TAGS:
        return Object.assign({}, state, {
            ...state,
            tags: {
                ...state.tags,
                loading: true,
            },
        });
    case actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE_TAGS, 'err'):
        return Object.assign({}, state, {
            ...state,
            tags: {
                ...state.tags,
                loading: false,
                error: true,
            },
        });
    case actionCreator(EmailTemplateTypes.LOAD_EMAIL_TEMPLATE_TAGS, 'res'):
        return Object.assign({}, state, {
            ...state,
            tags: {
                data: action.data,
                loading: false,
                error: false,
            },
        });

    default:
        return state;
    }
}
